export const DEFAULT_GITHUB_ENTERPRISE_API_HOST = "https://api.github.com";
export const DEFAULT_GITHUB_ENTERPRISE_HOST = "https://github.com";
